export enum AgoraCodecs {
    Vp8 =  "vp8",
    H264 = "h264"
}